import { Component, Inject, ViewEncapsulation } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ConfirmDialogData {
  titleKey: string;
  messageKey: string;
  messageParams?: any[];
  confirm: () => void;
}

@Component({
    selector: 'app-task-processing-hint',
    templateUrl: 'task-processing-hint.component.html',
    styleUrls: ['task-processing-hint.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TaskProcessingHintDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<TaskProcessingHintDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {}

  close() {
    this.dialogRef.close();
  }

}
